import { makeStyles } from '@material-ui/core/styles'
import { BorderColor } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  infoGenIa: {
    borderBottom: '1px solid rgba(0, 158, 226, .15)',
    borderRadius: '1px',
    display: 'flex',
    paddingBottom: '8px',
    alignItems: 'center',
    gap: '2px',
    color: theme.palette.primary.main,
  },
  infoGenIaIcon: {
    verticalAlign: 'middle',
    width: '20px',
    height: '20px',
  },
  summaryText: {
    marginTop: '8px',
    color: theme.palette.text.primary,
    fontSize: '13px',
    lineHeight: '15px',
  },
  keywordsTitle: {
    color: theme.palette.text.primary,
    fontSize: '10.5px',
    lineHeight: '12.6px',
    fontWeight: 'bold',
    marginTop: '16px',
    marginBottom: '8px',
  },
  keywords: {
    display: 'flex',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    gap: '4px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
  },
  keyword: {
    borderRadius: '10px',
    border: '1px solid',
    BorderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    padding: '2px 8px',
  },
  summaryBody: {
    padding: '10px',
    backgroundColor: theme.palette.details,
  },
}))

export default useStyles
